var React = require('react');

function ShoppingCartInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm7 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2-11a1 1 0 0 1 .894 1.447l-2.5 6A1 1 0 0 1 12.5 12h-6a1 1 0 0 1-.942-.664l-1.83-6.124C3.502 4.578 3.038 3 2 3H0V1h1.999c2.328 0 2.89 1.839 3.56 3H15z","fill":"currentColor","fillRule":"evenodd"}));
}

ShoppingCartInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ShoppingCartInline;

ShoppingCartInline.default = ShoppingCartInline;
